import React from 'react';
import style from './jetPortalWelcome.module.scss';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { LogoNoLinkTransparent } from '../common/logoNoLinkTransparent';

type JetPortalWelcomePresentationalProps = InjectedIntlProps & {
    welcomeMessage?: FormattedMessage.MessageDescriptor
};

const JetPortalWelcomePresentational: React.FC<JetPortalWelcomePresentationalProps> = ({intl, welcomeMessage}) => {
    return (
        <div className={style.welcomeContainer}>
            <div className={USE_MOBILE_APP_LOGIN_PAGE ? style.logoContainerMobile : style.logoContainer}>
                <LogoNoLinkTransparent />
            </div>
            {welcomeMessage &&
                <span className={style.welcomeMessage}>{intl.formatMessage(welcomeMessage)}</span>}
        </div>
    );
};

const JetPortalWelcome = injectIntl(JetPortalWelcomePresentational);

export { JetPortalWelcome };
